'use client';

import { usePathname, useSearchParams } from 'next/navigation';

import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { useSearchHistoryStore } from './_store/searchHistoryStore';
import { useSearchOverlayStore } from './_store/searchOverlayStore';
import { HeaderSearchOverlay } from './HeaderSearchOverlay';
import {
  DEFAULT_SEARCH_CATEGORY,
  SEARCH_CATEGORY_QUERY_KEY,
} from './search-categories';

export function HeaderSearchContainer() {
  const router = useCustomRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isOpen = useSearchOverlayStore((state) => state.isOverlayOpen);
  const closeOverlay = useSearchOverlayStore((state) => state.closeOverlay);
  const data = useSearchHistoryStore((state) => state.data);
  const add = useSearchHistoryStore((state) => state.add);
  const remove = useSearchHistoryStore((state) => state.remove);
  const clear = useSearchHistoryStore((state) => state.clear);

  const currentKeyword = searchParams?.get('q') ?? '';
  const currentCategory =
    searchParams?.get(SEARCH_CATEGORY_QUERY_KEY) ?? DEFAULT_SEARCH_CATEGORY;

  const submit = (keyword: string) => {
    const trimmed = keyword.trim();

    add(trimmed);
    closeOverlay();

    const nextParams = new URLSearchParams();
    nextParams.set('q', trimmed);
    if (currentCategory !== DEFAULT_SEARCH_CATEGORY) {
      nextParams.set(SEARCH_CATEGORY_QUERY_KEY, currentCategory);
    }
    const url = `${ROUTES.SEARCH.pathname}?${nextParams.toString()}`;

    if (pathname === ROUTES.SEARCH.pathname) {
      router.replace(url, { scroll: false });
      window.scrollTo(0, 0);
    } else {
      router.push(url);
    }
  };

  return (
    <HeaderSearchOverlay
      isOpen={isOpen}
      keyword={currentKeyword}
      onClose={closeOverlay}
      onSearch={submit}
      recentKeywords={data ?? []}
      onSelectRecent={submit}
      onRemoveRecent={remove}
      onClearRecent={clear}
    />
  );
}
